<template>
  <div class="container-wrapper-subsection">
    <div class="frame-5">
      <div class="frame-6">
        <p class="caisse-intuitive">
          Caisse intuitive &amp; gestion des ventes
        </p>

        <p class="notre-syst-me-de">
          Notre système de point de vente est conçu pour la rapidité et la
          facilité d&#39;utilisation, même pendant les périodes de pointe.
          Gérez toutes vos transactions avec fluidité.
        </p>

        <div class="frame-7">
          <div class="frame-8">
            <img
              class="circle-check-big"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big.svg"
            />

            <p class="p">Interface tactile moderne et réactive</p>
          </div>

          <div class="frame-8">
            <img
              class="circle-check-big"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-1.svg"
            />

            <p class="p">Gestion rapide des produits et des prix</p>
          </div>

          <div class="frame-8">
            <img
              class="circle-check-big"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-2.svg"
            />

            <p class="p">Intégration des options de paiement multiples</p>
          </div>

          <div class="frame-9">
            <img
              class="circle-check-big"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-3.svg"
            />

            <p class="p">
              Rapports de ventes détaillés et personnalisables
            </p>
          </div>
        </div>
      </div>

      <img
        class="img"
        alt="Image"
        src="https://c.animaapp.com/nNxA75tB/img/image-1.png"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ContainerWrapperSubsection",
});
</script>

<style>
.container-wrapper-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.container-wrapper-subsection .frame-5 {
  align-items: flex-start;
  display: grid;
  gap: 64px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 1200px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.container-wrapper-subsection .frame-6 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 21px;
  justify-content: center;
  min-width: 0;
  position: relative;
  width: 100%;
}

.container-wrapper-subsection .caisse-intuitive {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 45px;
  margin-top: -1.00px;
  position: relative;
}

.container-wrapper-subsection .notre-syst-me-de {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  position: relative;
}

.container-wrapper-subsection .frame-7 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  position: relative;
  max-width: 392px;
  width: 100%;
}

.container-wrapper-subsection .frame-8 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
  width: 100%;
}

.container-wrapper-subsection .circle-check-big {
  flex-shrink: 0;
  height: 20px;
  position: relative;
  width: 20px;
}

.container-wrapper-subsection .p {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  flex: 1;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
  white-space: normal;
  width: auto;
}

.container-wrapper-subsection .frame-9 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
  width: 100%;
}

.container-wrapper-subsection .img {
  aspect-ratio: 1.41;
  border-radius: 10px;
  display: block;
  min-height: 248.99px;
  min-width: 0;
  object-fit: cover;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .container-wrapper-subsection {
    padding: 80px 20px;
  }

  .container-wrapper-subsection .frame-5 {
    gap: 40px 28px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .container-wrapper-subsection .caisse-intuitive {
    font-size: 32px;
    line-height: 1.2;
  }
}

@media (max-width: 768px) {
  .container-wrapper-subsection {
    padding: 56px 16px;
  }

  .container-wrapper-subsection .frame-5 {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  .container-wrapper-subsection .caisse-intuitive {
    font-size: 28px;
    line-height: 34px;
  }

  .container-wrapper-subsection .notre-syst-me-de {
    font-size: 16px;
    line-height: 25px;
  }

  .container-wrapper-subsection .p {
    font-size: 15px;
    line-height: 23px;
  }

  .container-wrapper-subsection .img {
    min-height: 0;
  }
}

@media (max-width: 480px) {
  .container-wrapper-subsection {
    padding: 52px 16px;
  }

  .container-wrapper-subsection .caisse-intuitive {
    font-size: 24px;
    line-height: 30px;
  }
}
</style>
